export default "__VITE_ASSET__BddBSte3__"